module.exports = __webpack_public_path__ + "img/03.ef80a910.jpg";